import { render, staticRenderFns } from "./DashboardNewCustomers.vue?vue&type=template&id=0daf546a&scoped=true"
import script from "./DashboardNewCustomers.vue?vue&type=script&lang=js"
export * from "./DashboardNewCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf546a",
  null
  
)

export default component.exports